import { AttendeeSyncIcon } from "@/components/brand/attendee-sync-icon";
import { cn } from "@/lib/cn";

type BrandMarkProps = {
  className?: string;
  showIcon?: boolean;
  size?: "sm" | "md" | "lg";
  /** Gradient mark (default) or mono currentColor for dark sidebars. */
  iconVariant?: "gradient" | "mono";
};

export function BrandMark({
  className,
  showIcon = true,
  size = "md",
  iconVariant = "gradient",
}: BrandMarkProps) {
  return (
    <div
      className={cn(
        "rs-brand",
        size === "sm" && "rs-brand--sm",
        size === "lg" && "rs-brand--lg",
        className,
      )}
    >
      {showIcon ? <AttendeeSyncIcon variant={iconVariant} decorative /> : null}
      <div className="rs-brand-text">
        <span className="rs-brand-name">
          <span className="rs-brand-name-attendee">Attendee</span>
          <span className="rs-brand-name-sync">Sync</span>
        </span>
        <span className="rs-brand-byline">Any Event. Every Registrant.</span>
      </div>
    </div>
  );
}
